import { buildApp } from '@/app';
import 'sites/locale';
import 'sites/config/authorization';
import 'sites/config/board';
import 'sites/config/content';
import 'sites/config/relation';
import 'sites/config/router';
import 'sites/config/searcher';
import 'sites/config/texteditor';
import 'sites/config/navigation';
import './styles.css';

buildApp();
